import React from "react";
import GridContainer from "../../../../@jumbo/components/GridContainer";
import PageContainer from "../../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import { useParams } from "react-router";
 
import { Box, Button } from "@material-ui/core";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import { baseUrl } from "@jumbo/constants/baseUrl";
import axios from "../../../../services/auth/jwt/config";
import SectionTicketsContainer from "@jumbo/Dashboards/Events/EventSectionTickets/SectionTicketsContainer";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.eventsPage"} />, link: "/events" },
  { label: <IntlMessages id={"pages.SectionsTicketsPage"} />, isActive: true },
];

const SectionTickets = () => {
  const { id } = useParams();

  const handleDownload = async () => {
    const fileUrl = `${baseUrl}eventTicket/sectionTickets/file/${id}`;
    try {
      const response = await axios.get(fileUrl, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download the file", error);
    }
  };

  return (
    <PageContainer
      heading={<IntlMessages id="pages.SectionsTicketsPage" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Box
            marginBottom={"10px"}
            display={"flex"}
            justifyContent={"end"}
            alignItems={"center"}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<ArrowDownwardIcon />}
              onClick={handleDownload}
            >
              فایل گزارش
            </Button>
          </Box>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <SectionTicketsContainer />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default SectionTickets;
